import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { IndirSaleLineList } from '@/sc/entities/indirSaleLine/IndirSaleLineList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export const IndirSaleDetail = () => {
  
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'indirSaleLine', label: 'Lines', content: <IndirSaleLineList indirSaleObj={entityObj}/>},
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="INDIR_SALE" parentEntityId={entityObj.id} /> }
  ];

const reqParam = {
      allErrorsAccepted: true
    }

   const data = {
      title: 'Indir Sale Lifecycle',
      entity: 'INDIR_SALE',
      entityId: entityObj.id,
      augFieldDefs: (fieldToFieldDef) => {
        fieldToFieldDef.saleStatus = ''
      },
      addlReqData: reqParam,
      pluginCode: 'INDIR_SALE_PROC_ACTION_PLUGIN'
    }
  
    const augButtons = (buttons) => {
      if(['DRAFT'].includes(entityObj.status) && ['ERROR'].includes(entityObj.valStatus)) buttons.push(<ActionButton data={data} toolTip="Accept All Errors" icon={fas.faCheck} />);
    }

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}